<template>
  <b-row v-if="parentPath && path" style="margin-bottom:30px">
    <b-col md="12">
      <!--  :header="uniTranslation('S876')" -->
      <b-card
        class="card-panel"
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
      >
        <div class="row">
          <div v-show="isMixed" class="col-xl-6 col-lg-6 col-12">
            <MixedNumberOfPlate
              :to-validate="[
                path + '.numberOfPlates',
                path + '.highPerformancePlatePercentageValue'
              ]"
            >
            </MixedNumberOfPlate>
          </div>
          <div v-show="isMixed" class="col-xl-6 col-lg-6 col-12"></div>
          <div v-show="!isMixed" class="col-xl-6 col-lg-6 col-12">
            <PhePlateNumberPicker
              v-show="stepListVis"
              :parent-path="path"
              :local-path="'.numberOfPlates'"
              no-label
            >
            </PhePlateNumberPicker>
            <UnidataEditor
              v-show="!stepListVis"
              :parent-path="path"
              :name="'.numberOfPlates'"
              :validate-usr-value="true"
              :fixed-decimals="0"
            >
            </UnidataEditor>
          </div>
          <div v-show="!isMixed" class="col-xl-6 col-lg-6 col-12"></div>
          <div class="col-xl-6 col-lg-6 col-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.numberOfCircuitsPrimarySide'"
              :fixed-decimals="0"
              :disabilita="true"
            >
            </UnidataEditor>
          </div>

          <div class="col-xl-6 col-lg-6 col-12">
            <UnidataEditor
              :parent-path="path"
              :name="'.numberOfCircuitsSecondarySide'"
              :fixed-decimals="0"
              :disabilita="true"
            >
            </UnidataEditor>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import PhePlateNumberPicker from "../shared/PhePlateNumberPicker";
import MixedNumberOfPlate from "../shared/MixedNumberOfPlate";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    UnidataEditor,
    PhePlateNumberPicker,
    MixedNumberOfPlate
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
    // projectModality:{
    //   type: Number,
    //   required: true
    // },
    // projectType:{
    //   type: String,
    //   required: true
    // }
  },
  data() {
    return {
      path: null,
      calculationType: "",
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects", "isSaldobrasata"]),
    ...mapGetters("_geometryModule", ["stepList", "isMixed"]),
    ...mapGetters("_colorsModule", ["cardColors"]),

    stepListVis() {
      return this.stepList.length > 1;
    }
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    },
    cardColors() {
      this.setColors();
    }
  },
  mounted: function() {
    var that = this;
    if (this.parentPath && this.localPath) {
      this.path = this.parentPath + this.localPath;
    }
    that.setColors();
  },
  methods: {
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important";
      that.coloreTesto = that.cardColors[2];
      that.coloreBordo = that.cardColors[6];
    }
  }
};
</script>

<style lang="scss">
.no-border-bottom {
  div {
    .el-collapse-item__header {
      border-bottom: none;
    }
  }
}
</style>
